import { ApiHelper } from './helper/ApiHelper';

const apiHelper = new ApiHelper();
const API_CONTENT_TOKEN = process.env.VUE_APP_CONTENT_TOKEN;

import { AESService } from "./AES.js";
let aesService = new AESService()
export class PartnerService {
    constructor() {}
        // getEbid(companyCode, fromDate, toDate) {
        //     const uri = `/api/eip/partner/rfq-list/company-code/${companyCode}?from=${fromDate}&to=${toDate}`
        //     return apiHelper.post(uri)
        // }

    getDocumentNumberSearch(referenceNumber) {
        const uri = `/api/opengrievance/validateorder?referenceNumber=${referenceNumber}`
        return apiHelper.get(uri)
    }
    getReasonforgrievance() {
        const uri = `/api/opengrievance/misc-type-details/misc-code/15`
        return apiHelper.get(uri)
    }
    submitGrievanceReq(data) {
        const uri = `/api/opengrievance/Submit`
        return apiHelper.post(uri, data)
    }
    getKYCAcceptedDate(data) {
        const uri = `/api/rekyc/getGeneralDetails`
        return apiHelper.post(uri, data)
    }
    submitKYCAcceptedDate(data) {
        const uri = `/api/rekyc/submitGeneralDetails`
        return apiHelper.post(uri, data)
    }
    getEbid(data) {
        const uri = `/api/eip/partner/rfq`
        return apiHelper.post(uri, data)
    }
    userLogout(data) {
        //data.loginAuditNumber = ''
        const uri = `/api/useraudit/logout`
        return apiHelper.post(uri, data)
    }
    getPartnerInfo(isAdmin, pId) {
        var uri = `/api/partner/info`
        if (isAdmin) {
            uri = `/api/partner/info/partnerId?pId=${pId}`
        }
        return apiHelper.get(uri);
    }
    getDeclarationStatus() {
        const uri = `/api/retrive/tdsDeclaration`
        return apiHelper.get(uri);
    }
    getTaxContactDeclarationStatus() {
        var data = null;
        const uri = `/api/retrive/gstnotification`
        return apiHelper.post(uri, data);
    }
    submitTaxContactDeclaration(data) {
        const uri = `/api/submit/gstnotification`
        return apiHelper.post(uri, data);
    }
    getPartnerInvoiceInfo() {
        const uri = `/api/partner-invoice`
        return apiHelper.get(uri);
    }

    getPartnerDetails(categoryCode) {
        const uri = `/api/partner-profile/modules/category-code/${categoryCode}`
        return apiHelper.get(uri)
    }

    getAnswerByModuleCodeAndGroupCode(moduleCode, groupCode, categoryCode) {
        const uri = `/api/partner-summaries/module-code/${moduleCode
            }/group-code/${groupCode}/category-code/${categoryCode}`
        return apiHelper.get(uri)
    }
    downLoadDocument(documentId) {
        const uri = `/api/fileDownload/${documentId}`;
        return apiHelper.downloadFile(uri);
    }
    getNotificationAlert(categoryCode) {
        const uri = `/api/partner-notification/alert/category-code/${categoryCode}`
        return apiHelper.get(uri)
    }
    getPartnerCategories(work, partnerId) {
        const uri = `/api/partner/order-summary/category/${work}?partnerId=${partnerId}`
        return apiHelper.get(uri)
    }
    getJobDetails(data, size, page) {
        const uri = `/api/partner/order-summary?size=${size}&page=${page}`
        return apiHelper.post(uri, data)
    }
    getJobDetailsById(partnerId, work, size, page) {
        const uri = `/api/partner/ordersummary?partnerId=${partnerId}&jobType=${work}&size=${size}&page=${page}`
        return apiHelper.get(uri)
    }
    getWorkCategoryDetails(work, poNumber) {
        const uri = `/api/partner/order-summary/${work}-number?${work}-number=${poNumber}`
        return apiHelper.get(uri)
    }
    getPoInvoiceDetails(work, poNumber, size, page) {
        const uri = `/api/partner/order-summary/${work}-number/invoice-details?${work}-number=${poNumber}&size=${size}&page=${page}`
        return apiHelper.get(uri)
    }
    getQuickLinkQuestions(questionCode, moduleCode, answerNumber) {
        const uri = `/api/quick-link/question/question-code/${questionCode}/module-code/${moduleCode}/answer-number/${answerNumber}`
        return apiHelper.get(uri)
    }
    getQuicklikFirstQuestion(categoryCode) {
        const uri = `/api/summary/profile/quick-links/add-more/category-code/${categoryCode}`
        return apiHelper.get(uri)

    }
    quickLinkDraft(data) {
        const uri = `/api/quick-link/draft`
        return apiHelper.postFile(uri, data);
    }
    quickLinkPage(categoryCode, companyCode) {
        // const uri = `/api/summary/profile/quick-links/category-code/${categoryCode}/user-name/${userName}`
        const uri = `/api/summary/profile/quick-links/category-code/${categoryCode}/companyCode/${companyCode}`
        return apiHelper.get(uri);
    }
    quickLinkContactGetDataPage(data) {
        const uri = `/api/taxContact/getTaxContactDetails`
        return apiHelper.post(uri, data);
    }
    quickLinkContactSaveDataPage(data) {
        const uri = `/api/taxContact/saveTaxContact`
        return apiHelper.post(uri, data);
    }
    getTopOrderDashboardData(selectedWork) {
        const uri = `/api/dashboard/top-categories/${selectedWork}`
        return apiHelper.get(uri)
    }
    getPartnertype(companyCode, pId) {
        var uri = `/api/partner/partner-type/company-code/${companyCode}`
        if (pId) {
            uri = `/api/partner/partner-type-byPId/company-code/${companyCode}?pId=${pId}`
        }
        return apiHelper.get(uri)
    }
    getAllGsts(companyCode) {
        const uri = `/api/allGst/companyCode/${companyCode}`
        return apiHelper.get(uri)
    }
    getUpdatedByCommunity(uby) {
        const uri = `/api/getUpdatedByCommunity?updatedby=${uby}`
        return apiHelper.get(uri)
    }
    deleteAddressQL(data) {
        const uri = `/api/addressQl/deleteAddressQl`
        return apiHelper.post(uri, data)
    }
    categorySwitch(companyCode) {
        const uri = `/api/common-view/categorySwitch/companyCode/${companyCode}`
        return apiHelper.get(uri)
    }
    getDashboardOrder(selectedWork, startDate, endDate) {
        const uri = `/api/dashboard/orders/${selectedWork}?from=${startDate}&to=${endDate}`
        return apiHelper.get(uri)
    }
    getInvoiceSummary(selectedWork, startDate, endDate) {
        if (startDate && endDate) {
            const uri = `/api/dashboard/invoice-summary/${selectedWork}?from=${startDate}&to=${endDate}`
            return apiHelper.get(uri)
        } else {
            const uri = `/api/dashboard/invoice-summary/${selectedWork}`
            return apiHelper.get(uri)
        }
    }
    getInvoiceGraphData(selectedWork, startDate, endDate) {
        const uri = `/api/dashboard/received-vs-outstandin/${selectedWork}?from=${startDate}&to=${endDate}`
        return apiHelper.get(uri)
    }
    getStatesForGST(countryCode) {
        const uri = `/api/state/country/${countryCode}`
        return apiHelper.get(uri)
    }
    userCategoryAudit(categoryCode, companyCode) {
        const uri = `/api/user-category-audit/category-code/${categoryCode}/company-code/${companyCode}`
        return apiHelper.post(uri)
    }
    gstDealers() {
        const uri = `/api/gstin-dealer-type`
        return apiHelper.get(uri)
    }
    getGstCountry() {
        const uri = `/api/country`;
        return apiHelper.get(uri);
    }
    getGstStates(countryCode) {
        const uri = `/api/state/country/${countryCode}`
        return apiHelper.get(uri)
    }
    contactDraft(data) {
        const uri = `/api/partner/quick-link/contact`
        return apiHelper.postFile(uri, data);
    }
    addressQL(data) {
        const uri = `/api/addressQl/addAddress`
        return apiHelper.postFile(uri, data);
    }
    statutoryQL(data) {
        const uri = `/api/statutoryQl/saveStatutoryDraft`
        return apiHelper.postFile(uri, data);
    }
    deleteCertificate(data) {
        const uri = `/api/partner/quick-link/delete/certificate`
        return apiHelper.remove(uri, data);
    }
    deleteContact(data) {
        const uri = `/api/partner/quick-link/delete/contact`
        return apiHelper.post(uri, data);
    }
    getGstVertical(companyCode) {
        const uri = `/api/partner-business-type/company-code/${companyCode}`
        return apiHelper.get(uri)
    }
    getApprovedGstDetailsForLoggedinPartner(companyCode) {
        const uri = `/api/gstin/company-code/${companyCode}`
        return apiHelper.get(uri)
    }
    getApprovedGstDetails(companyCode) {
        const uri = `/api/allGst/companyCode/${companyCode}`
        return apiHelper.get(uri)
    }
    getPendingGstDetails(companyCode) {
        const uri = `/api/gstin/q-l/company-code/${companyCode}`
        return apiHelper.get(uri)
    }
    saveGstDetail(data) {
        const uri = `/api/gstin`
        return apiHelper.post(uri, data)
    }
    updateGSTDetail(data) {
        const uri = `/api/gstin`
        return apiHelper.put(uri, data)
    }
    updateApprovedGstDetails(data) {
        const uri = `/api/approved-gstin`
        return apiHelper.put(uri, data)
    }
    editGstDetails(companyCode, slno) {
        const uri = `/api/gst/edit-display/company-code/${companyCode}/slno/${slno}`
        return apiHelper.get(uri)
    }
    editApprovedGstList(companyCode, slno) {
        const uri = `/api/gst/approved-edit-display/company-code/${companyCode}/slno/${slno}`
        return apiHelper.get(uri)
    }
    gstApproval(data) {
        const uri = `/api/partnerportal/modification/financial-submit`
        return apiHelper.post(uri, data)
    }
    getFinancialYearDropdown(categoryCode, companyCode) {
        const uri = `/api/finance-year/category-code/${categoryCode}/company-code/${companyCode}`
        return apiHelper.get(uri)
    }
    saveFinanceDetail(data) {
        const uri = `/api/finance/draft`
        return apiHelper.post(uri, data)
    }
    getApprovedAddrDetails(data) {
        const uri = `/api/addressQl/getApprovedAddressDetails`
        return apiHelper.post(uri, data)
    }
    getQLAddrDetails(data) {
        const uri = `/api/addressQl/getQlAddressDetails`
        return apiHelper.post(uri, data)
    }
    getApprovedStatutoryDetails(data) {
        const uri = `/api/statutoryQl/getApprovedStatutory`
        return apiHelper.post(uri, data)
    }
    getQLStatutoryDetails(data) {
        const uri = `/api/statutoryQl/getQuickLinkStatutory`
        return apiHelper.post(uri, data)
    }
    deleteFinanceDetail(data) {
            const uri = `/api/remove/finance-detail`
            return apiHelper.post(uri, data);
        }
        // partnerGstDocumentNo(categoryCode, companyCode) {
        //     const uri = `/api/onboard-answer-head/category-code/${categoryCode}/company-code/${companyCode}/document/GST`
        //     return apiHelper.get(uri)
        // }
    gstDocumentNumber(companyCode, categoryCode) {
        const uri = `/api/gst/document-number/company-code/${companyCode}/category-code/${categoryCode}`
        return apiHelper.get(uri)
    }
    quicklinkDocumentNumber(companyCode, categoryCode) {
        const uri = `/api/quicklink/document-number/company-code/${companyCode}/category-code/${categoryCode}`
        return apiHelper.get(uri)
    }
    quicklinkApproval(data) {
        //const uri = `/api/quicklink/submit`
        const uri = `/api/partnerportal/modification/technical-submit`
        return apiHelper.post(uri, data)
    }
    getCodeOfConduct(companyCode, type) {
        const uri = `/api/coc/status/company-code/${companyCode}/type/${type}`
        return apiHelper.get(uri);
    }
    reviewofCodeOfConduct(companyCode, type) {
        const uri = `/api/coc/company-code/${companyCode}/type/${type}`
        return apiHelper.post(uri);
    }
    saveBankDetail(data, isCreate) {
        const uri = `/api/quicklink/bank/draft?isCreate=${isCreate}`
        return apiHelper.post(uri, data);
    }
    saveBankDetailAdmin(data) {
        const uri = `/api/common-view/admin/bank/submit?isCreate=Y`
        if (sessionStorage.getItem('useridadmin')) {
            data.userId = sessionStorage.getItem('useridadmin')
        }
        return apiHelper.post(uri, data);
    }
    saveBankDetailCustomer(data) {
        const uri = `/api/customer/save/bank-details`
        return apiHelper.post(uri, data);
    }
    getEvaluationForm(companyCode, jobCode, orderNumber, orderType, partnerNumber) {
        const uri = `/api/questions?company-code=${companyCode}&job-code=${jobCode}&order-number=${orderNumber}&order-type=${orderType}&partner-number=${partnerNumber}`
        return apiHelper.get(uri);
    }

    getFeedbackFormDetails() {
        const uri = `/api/histories`
        return apiHelper.get(uri);
    }
    getClaimDraftFormDetails(cc) {
        const uri = `/api/ClaimRequest/SavedDraft/companyCode/${cc}`
        return apiHelper.get(uri);
    }
    getClaimHistoriesFormDetails(cc) {
        const uri = `/api/ClaimRequest/history/companyCode/${cc}`
        return apiHelper.get(uri);
    }
    claimClose(data) {
        const uri = `/api/claimRequest/close`
        return apiHelper.post(uri, data);
    }
    claimReasonChange(pcrNumber, type) {
        const uri = `/api/updateGrievanceType/documentNumber/${pcrNumber}/type/${type}`
        return apiHelper.get(uri);
    }
    claimReopen(data) {
        const uri = `/api/claimrequest/reopen`
        return apiHelper.post(uri, data);
    }
    getFeedbackHistory(companyCode, jobCode, orderNumber, orderType, partnerNumber, documentNumber) {
        const uri = `/api/history?company-code=${companyCode}&job-code=${jobCode}&order-number=${orderNumber}&order-type=${orderType}&partner-number=${partnerNumber}&document-number=${documentNumber}`
        return apiHelper.get(uri);
    }
    getFeedbackDraftDetails() {
        const uri = `/api/drafts`
        return apiHelper.get(uri);
    }

    saveDynamicDataAsDraft(data) {
        const uri = `/api/draft`
        return apiHelper.post(uri, data);
    }
    saveClaimDataAsDraft(data) {
        const uri = `/api/ClaimRequest/draft`
        return apiHelper.post(uri, data);
    }
    saveClaimDataSubmit(data) {
        const uri = `/api/claimrequest/Submit`
        return apiHelper.post(uri, data);
    }
    saveDynamicData(data) {
        const uri = `/api/submit`
        return apiHelper.post(uri, data);
    }

    getDraftDetails(companyCode, jobCode, orderNumber, orderType, partnerNumber, documentNumber) {
        const uri = `/api/questions?company-code=${companyCode}&job-code=${jobCode}&order-number=${orderNumber}&order-type=${orderType}&partner-number=${partnerNumber}&document-number=${documentNumber}`
        return apiHelper.get(uri);
    }
    deleteBankDetail(data) {
        const uri = `/api/quicklink/delete/bank`
        return apiHelper.post(uri, data);
    }
    getEIPPartnerDetails() {
        const uri = `/api/eip/partner/detail`
        return apiHelper.get(uri);
    }
    getJobDropDownValues(jobCode) {
        const uri = `/api/vendor/order-summary?jobType=${jobCode}`
        return apiHelper.get(uri);
    }
    getClaimJobDropDownValues(companyCode) {
        const uri = `/api/claim/vendor/order-summary?companyCode=${companyCode}`
        return apiHelper.get(uri);
    }
    getJobDropDownOrderWise(vendorCode) {
        vendorCode = aesService.EncodeUsingAES(vendorCode);
        const uri = `/api/vendor/partenrwise`
        var data = { "vendorCode": vendorCode }
        return apiHelper.post(uri, data)
    }
    getWorkorderDropDownValues(jobType, jobCode) {
        const uri = `/api/vendor/jobCodes?job-code=${jobCode}&jobType=${jobType}`
        return apiHelper.get(uri);
    }
    getClaimWorkorderDropDownValues(jobCode, companyCode) {
        const uri = `/api/claim/vendor/jobCodes?jobCode=${jobCode}&companyCode=${companyCode}`
        return apiHelper.get(uri);
    }
    getWorkflowHistory(companyCode, answerNumber) {
        const uri = `/api/workflow/history?company-code=${companyCode}&document-number=${answerNumber}`
        return apiHelper.get(uri);
    }
    checkMandatoryQuestion(data) {
        const uri = `/api/feeback/mandatoryquestions/check`
        return apiHelper.post(uri, data);
    }
    getNotificationDetails() {
        const uri = `/api/notification`
        return apiHelper.get(uri);
    }

    setNotificationStatus(data) {
        const uri = `/api/notification`
        return apiHelper.put(uri, data);
    }

    setTestimonials(data) {
        const uri = `/api/testimonials`
        return apiHelper.post(uri, data);
    }
    getTestimonials() {
        const uri = `/api/testimonials`
        return apiHelper.get(uri);
    }
    uploadCompanyLogo(data) {
        const uri = "/api/testimonials/fileUpload"
        return apiHelper.postFile(uri, data);
    }
    uploadProfilePicture(data) {
        const uri = "/api/profilePicture/fileUpload"
        return apiHelper.postFile(uri, data);
    }
    downloadCompanyLogo(uniqueId) {
        const uri = `/api/testimonials/fileDownload/${uniqueId}`
        return apiHelper.getImage(uri);
    }
    downloadProfilePicture(uniqueId) {
        const uri = `/api/profilePicture/fileDownload/${uniqueId}`
        return apiHelper.getImage(uri);
    }
    getApprovedTestimonials() {
        const uri = `/api/testimonials/approved`
        return apiHelper.get(uri);
    }
    getPartnerBranchDetails(data) {
        const uri = `/api/branch-details`
        return apiHelper.post(uri, data);
    }

    getPartnerSavedNewBranches() {
        const uri = `/api/partner/new-branches`
        return apiHelper.get(uri);
    }

    getPartnerAllBranches(categoryCode, companyCode) {
        const uri = `/api/partner/all-branches/category/${categoryCode}/company/${companyCode}`
        return apiHelper.get(uri)
    }

    savePartnerBranchDetails(data, pId) {
        var uri = `/api/partner/new-branch`
        if (pId) {
            uri = `/api/partner/new-branch-byPId?pId=${pId}`
        }
        return apiHelper.post(uri, data);
    }
    saveCustomerBranchDetails(data) {
        var uri = `/api/customer/save/branch`
        return apiHelper.post(uri, data);
    }

    partnerBranchNameUnique(branchName, categoryCode, companyCode) {
        const uri = `/api/partner/validate/branch-name/${branchName}/category/${categoryCode}/company/${companyCode}`
        return apiHelper.get(uri);
    }

    partnerBranchStreetUnique(branchStreet, categoryCode, companyCode) {
        const uri = `/api/partner/validate/branch-street/${branchStreet}/category/${categoryCode}/company/${companyCode}`
        return apiHelper.get(uri);
    }
    getFileTypesByModule(moduleCode) {
        const uri = `/api/files/module/${moduleCode}`
        return apiHelper.get(uri);
    }

    getPartnerClassification() {
        const uri = `/api/branch-partner/partner-classification`
        return apiHelper.get(uri)
    }

    getPartnerApprovedBusinessCategories() {
        const uri = `/api/partner/categories-approved`;
        return apiHelper.get(uri);
    }

    getPartnerNotApprovedBusinessCategories() {
        const uri = `/api/partner/categories-not-approved`;
        return apiHelper.get(uri);
    }

    getPartnerCategoriesWhichCanAddMore(categoryCode) {
        const uri = `/api/partner/business-category/categories/category-code?categoryCode=` + categoryCode;
        return apiHelper.get(uri);
    }

    getPartnerSubCategoriesWhichCanAddMore(partnerType, categories, subcategories) {
        const uri = `/api/partner/sub-categories/partner-type/${partnerType}/category-code?categoryCode=` + categories + `&subCategoryCode=` + subcategories;
        return apiHelper.get(uri);
    }

    savePartnerAdditionalCategories(data) {
        const uri = `/api/partner/new-categories`;
        return apiHelper.post(uri, data)
    }
    getGstCategories(companyCode) {
        const uri = `/api/gst/category/${companyCode}`
        return apiHelper.get(uri);
    }
    getGstCategoriesOnboarding(companyCode, categoryCode) {
        const uri = `/api/gst/category/${companyCode}/categorycode/${categoryCode}`
        return apiHelper.get(uri);
    }
    getGstSubCategories(categoryCode, companyCode) {
        const uri = `/api/gst/sub-category/${categoryCode}/company/${companyCode}`
        return apiHelper.get(uri);
    }
    setProfilePicture(profilePictureDocId, profilePictureSiteUrl) {
        let data = {};
        data.docId = profilePictureDocId;
        data.siteUrl = profilePictureSiteUrl;
        const uri = `/api/partner/contact/profilepicture`;
        return apiHelper.post(uri, data);
    }
    getProfilePicture() {
        const uri = `/api/partner/contact/profilepicture`
        return apiHelper.get(uri);
    }

    savePartnerFeedbackSuggestions(data) {
        const uri = `/api/partner/feedback-suggestions/save`
        return apiHelper.post(uri, data);
    }

    gstNumberVerification(gstNumber) {
        const uri = `/api/statutory/gst/verify?gstin=` + gstNumber;
        return apiHelper.get(uri);
    }
    getKycDetails(companyCode, partnerId) {
        const uri = `/api/rekyc/partnerDetails/companyCode/${companyCode}/partnerId/${partnerId}`;
        return apiHelper.get(uri);
    }
    submitKycDetails(data) {
        const uri = `/api/rekyc/submitKycDetails`;
        return apiHelper.post(uri, data);
    }
    submittedDocumentDetails(companyCode) {
        const uri = `/api/rekyc/wfDocumentDetails/companyCode/${companyCode}`;
        return apiHelper.get(uri);
    }
}